import { colorPallete } from '@configs/color-pallete';
import { ConsultantTypeEnum } from '@models/ocs/doctor';
import Icon from '@utilities/icon';
import classNames from 'classnames';

type ConsultantTypeProps = {
  type: ConsultantTypeEnum;
  iconColor?: string;
  className?: string;
};

const ConsultantType = ({
  type,
  iconColor,
  className,
}: ConsultantTypeProps) => {
  const renderIconName = () => {
    switch (type) {
      case ConsultantTypeEnum.ONDEMANDCALL:
        return 'CallLeft';
      case ConsultantTypeEnum.SCHEDULEDCALL:
        return 'CalendarFill';
      case ConsultantTypeEnum.RX:
        return 'StickyNoteFill';
      case ConsultantTypeEnum.ONDEMANDCHAT:
        return 'DialogBoxTextFillLeft';
      default:
        return 'PhoneFill';
    }
  };

  const renderText = () => {
    switch (type) {
      case ConsultantTypeEnum.ONDEMANDCALL:
        return 'تلفنی فوری';
      case ConsultantTypeEnum.SCHEDULEDCALL:
        return 'مشاوره زمانبندی';
      case ConsultantTypeEnum.RX:
        return 'نسخه الکترونیک';
      case ConsultantTypeEnum.ONDEMANDCHAT:
        return 'متنی فوری';
      default:
        return '';
    }
  };

  return (
    <div
      className={classNames(
        className,
        'w-full flex items-center justify-center gap-x-0.5',
      )}
    >
      <Icon
        name={renderIconName()}
        width={1}
        height={1}
        fill={iconColor ? iconColor : colorPallete?.content.primary}
      />
      <span className="text-Label/2xSmall text-content-primary">
        {renderText()}
      </span>
    </div>
  );
};

export default ConsultantType;
